import React, { useEffect, useState } from 'react';
import { useSnackbar } from '../contexts/SnackbarProvider';
import axiosInstance from '../utils/axiosInstance';
import { Box, Button, Typography, TextField, MenuItem, Stack, Select } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
const SetDeviceUUID = ({ onUuidSet }) => {
  const { showSnackbar } = useSnackbar();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  // 倉庫リスト取得
  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const res = await axiosInstance.get('/picking/warehouses-with-devices', { params: { activeOnly: true } });
        setWarehouses(res.data || []);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') console.error(err);
        setWarehouses([]);
      }
    };
    fetchWarehouses();
  }, []);

  // 倉庫選択に応じた端末リスト
  const devices = selectedWarehouse
    ? warehouses.find(w => w.warehouse_id === selectedWarehouse)?.devices || []
    : [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDevice) return;

    try {
      const response = await axiosInstance.post('/picking/set-device-uuid', { device_id: selectedDevice });
      const deviceUuid = response.data.uuid;
      localStorage.setItem('device_uuid', deviceUuid);
      onUuidSet(deviceUuid);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error(err);
      showSnackbar(err?.response?.data?.message || '端末設定に失敗しました', 'error');
    }
  };

  return (
    <>
      {/* タイトル */}
      <Stack direction="row" spacing={1} alignItems="center" mb={3}>
        <SettingsIcon color="primary" />
        <Typography variant="h3">デバイス登録設定</Typography>
      </Stack>

      {/* フォーム */}
      <Box component="form" onSubmit={handleSubmit}>
        <Stack alignItems="center" spacing={2}>
          <TextField
            select
            value={selectedWarehouse ?? ''}
            SelectProps={{
              displayEmpty: true,
              renderValue: (value) => {
                if (!value) return <span style={{ color: '#aaa' }}>倉庫を選択してください</span>;
                const selected = warehouses.find(w => w.warehouse_id === value);
                return selected?.warehouse_name || '';
              }
            }}
            onChange={(e) => { setSelectedWarehouse(e.target.value); setSelectedDevice(null); }}
          >
            <MenuItem value="">倉庫を選択してください</MenuItem>
            {warehouses.map(w => (
              <MenuItem key={w.warehouse_id} value={w.warehouse_id}>{w.warehouse_name}</MenuItem>
            ))}
          </TextField>

          {selectedWarehouse && (
            <TextField
              select
              label="端末を選択"
              value={selectedDevice ?? ''}
              SelectProps={{
                displayEmpty: true,
                renderValue: (value) => {
                  if (!value) return <span style={{ color: '#aaa' }}>端末を選択してください</span>;
                  const selected = devices.find(d => d.device_id === value);
                  return selected?.device_name || '';
                }
              }}
              onChange={(e) => setSelectedDevice(e.target.value)}
              required
            >
              <MenuItem value="">選択してください</MenuItem>
              {devices.map(d => (
                <MenuItem key={d.device_id} value={d.device_id}>{d.device_name}</MenuItem>
              ))}
            </TextField>
          )}

          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={!selectedDevice}
            sx={{ minWidth: 200 }}
          >
            設定する
          </Button>
        </Stack>      </Box>
    </>
  );
};

export default SetDeviceUUID;
